import { Link } from "react-router-dom";
import type { Video } from "@/types/video";
import { formatViews } from "@/utils/format";
import { sortVideos } from "@/utils/videoFilters";

interface HotRankingProps {
  videos: Video[];
}

const rankStyles = [
  "bg-accent-500 text-background-50",
  "bg-accent-400 text-background-50",
  "bg-accent-300 text-foreground-950",
];

export default function HotRanking({ videos }: HotRankingProps) {
  const ranking = sortVideos(videos, "hot").slice(0, 8);

  return (
    <ol className="grid grid-cols-1 gap-3 lg:grid-cols-2">
      {ranking.map((video, index) => (
        <li key={video.id}>
          <Link
            to={`/video/${video.id}`}
            className="group flex items-center gap-4 rounded-lg border border-background-200 bg-background-50 p-3 transition-all duration-300 hover:border-accent-300 hover:bg-accent-50/60"
          >
            <span
              className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-md font-heading text-sm font-bold ${
                index < 3 ? rankStyles[index] : "bg-background-200 text-foreground-600"
              }`}
            >
              {index + 1}
            </span>
            <span className="relative h-14 w-24 shrink-0 overflow-hidden rounded-md bg-background-100">
              <img
                src={video.cover}
                alt={`${video.title} 封面`}
                title={`${video.title} - 啪啪视频`}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
            </span>
            <span className="min-w-0 flex-1">
              <span className="line-clamp-2 text-sm font-medium text-foreground-900 transition-colors duration-200 group-hover:text-accent-700">
                {video.title}
              </span>
              <span className="mt-1 flex flex-wrap items-center gap-x-3 text-xs text-foreground-500">
                <span className="inline-flex items-center gap-1">
                  <i className="ri-play-circle-line"></i>
                  {formatViews(video.views)} 次播放
                </span>
                <span className="inline-flex items-center gap-1">
                  <i className="ri-price-tag-3-line"></i>
                  {video.categoryName}
                </span>
              </span>
            </span>
          </Link>
        </li>
      ))}
    </ol>
  );
}